let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9J4KV")).then(() => parcelRequire('g1PaI'));